<template>
  <div class="map-main">

    <div class="map-control-top">

      <div class="filters">

        <div class="filter-item mr-2">
          <b-form-checkbox v-model="setView" :value="true" :checked="setView"
            class="custom-control-item custom-control-success">
            {{ $t('Enable Center View') }}
          </b-form-checkbox>
        </div>
        <div class="filter-item">
          <b-form-checkbox v-model="eventFilter" :disabled="eventFilterDisabled" @change="drawFilterdRoute()"
            value="moving" class="custom-control-item custom-control-secondery">
            {{ $t('Moving') }}
          </b-form-checkbox>

        </div>
        <div class="filter-item">
          <b-form-checkbox v-model="eventFilter" :disabled="eventFilterDisabled" @change="drawFilterdRoute()" value="stop"
            class="custom-control-item custom-control-danger">
            {{ $t('Stop') }}
          </b-form-checkbox>
        </div>
        <div class="filter-item">
          <b-form-checkbox v-model="eventFilter" :disabled="eventFilterDisabled" @change="drawFilterdRoute()" value="pto"
            class="custom-control-item custom-control-warning">
            {{ $t('PTO') }}
          </b-form-checkbox>
        </div>

        <div class="filter-item">
          <b-form-checkbox v-model="eventFilter" :disabled="eventFilterDisabled" @change="drawFilterdRoute()"
            value="sweep" class="custom-control-item custom-control-warning">
            {{ $t('SWEEP') }}
          </b-form-checkbox>
        </div>


      </div>
      <div class="filters">
        <div class="filter-item">
          <b-form-checkbox v-model="DevicePlanGeofencesIsChecked" :value="true" @change="getDevicePlanGeofences()"
            :disabled="geofencesFilterDisabled" class="custom-control-secondary">
            {{ $t('DEVICE PLANS') }}
          </b-form-checkbox>
        </div>

        <div class="filter-item">


          <b-form-checkbox v-model="CAMP_AREA_IS_CHECKED" :value="true" @change="setGeofenceFilter('CAMP_AREA')"
            :disabled="geofencesFilterDisabled" class="custom-control-secondary">
            {{ $t('CAMP_AREA') }}
          </b-form-checkbox>
          <!-- <b-form-checkbox  v-model="geofencesFilter" value="CAMP_AREA"
              :disabled="geofencesFilterDisabled" class="custom-control-secondary">
              {{ $t('CAMP_AREA') }}
            </b-form-checkbox> -->
        </div>
        <div class="filter-item">
          <b-form-checkbox v-model="WORK_AREA_IS_CHECKED" :value="true" @change="setGeofenceFilter('WORK_AREA')"
            :disabled="geofencesFilterDisabled" class="custom-control-secondary">
            {{ $t('WORK_AREA') }}
          </b-form-checkbox>
        </div>
        <div class="filter-item">
          <b-form-checkbox v-model="LANDFILL_AREA_IS_CHECKED" :value="true" @change="setGeofenceFilter('LANDFILL_AREA')"
            :disabled="geofencesFilterDisabled" class="custom-control-secondary">
            {{ $t('LANDFILL_AREA') }}
          </b-form-checkbox>
        </div>
        <div class="filter-item">
          <b-form-checkbox v-model="IRRIGATION_AREA_IS_CHECKED" :value="true" :disabled="geofencesFilterDisabled"
            @change="setGeofenceFilter('IRRIGATION_AREA')" class="custom-control-secondary">
            {{ $t('IRRIGATION_AREA') }}
          </b-form-checkbox>
        </div>
        <div class="filter-item">
          <b-form-checkbox v-model="FILL_AREA_IS_CHECKED" :value="true" :disabled="geofencesFilterDisabled"
            @change="setGeofenceFilter('FILL_AREA')" class="custom-control-secondary">
            {{ $t('FILL_AREA') }}
          </b-form-checkbox>
        </div>
        <div class="filter-item">
          <b-form-checkbox v-model="FORBIDDEN_AREA_IS_CHECKED" :value="true" @change="setGeofenceFilter('FORBIDDEN_AREA')"
            :disabled="geofencesFilterDisabled" class="custom-control-secondary">
            {{ $t('FORBIDDEN_AREA') }}
          </b-form-checkbox>
        </div>
      </div>

    </div>
    <l-map ref="mapRef" :zoom="zoom" :center="center">
      <l-tile-layer :url="url"></l-tile-layer>
    </l-map>


    <div class="customizer  d-none d-md-block customizer-left" :class="{ 'open': isCustomizerOpenLeft }">

      <!-- Toggler -->
      <b-link class="customizer-toggle d-flex align-items-center justify-content-center"
        @click="isCustomizerOpenLeft = !isCustomizerOpenLeft">
        <feather-icon icon="SettingsIcon" size="15" class="spinner" />
      </b-link>
      <!-- /Toggler -->

      <!-- Header -->
      <div class="customizer-section d-flex justify-content-between align-items-center">
        <div>
          <h4 class="text-uppercase mb-0">
            {{ $t('Display All Events') }}
          </h4>
          <!-- <small>Customize &amp; Preview in Real Time</small> -->
        </div>
        <feather-icon icon="XIcon" size="18" class="cursor-pointer"
          @click="isCustomizerOpenLeft = !isCustomizerOpenLeft" />
      </div>
      <!-- Header -->

      <vue-perfect-scrollbar :settings="perfectScrollbarSettings" class="ps-customizer-area scroll-area">
        <events-list :items="eventItems" :generalInfo="eventsGeneralInfo" :loading="eventListLoading"
          @getEventPoint="getEventPoint" />
      </vue-perfect-scrollbar>

    </div>



    <div class="customizer d-none d-md-block  customizer-rigth" :class="{ 'open': isCustomizerOpenRight }">

      <!-- Toggler -->
      <b-link class="customizer-toggle d-flex align-items-center justify-content-center"
        @click="isCustomizerOpenRight = !isCustomizerOpenRight">
        <feather-icon icon="SettingsIcon" size="15" class="spinner" />
      </b-link>
      <!-- /Toggler -->

      <!-- Header -->
      <div class="customizer-section d-flex justify-content-between align-items-center">
        <div>
          <h4 class="text-uppercase mb-0">
            {{ $t('Filter Geofences') }}
          </h4>
          <!-- <small>Customize &amp; Preview in Real Time</small> -->
        </div>
        <feather-icon icon="XIcon" size="18" class="cursor-pointer"
          @click="isCustomizerOpenRight = !isCustomizerOpenRight" />
      </div>
      <!-- Header -->



      <vue-perfect-scrollbar :settings="perfectScrollbarSettings" class="ps-customizer-area scroll-area">

        <GeofencesFliter :categories-options="gCategoriesOptions" :categories-filter.sync="gCategoriesFilter"
          :contracts-options="gContractsOptions" :contracts-filter.sync="gContractsFilter"
          :owners-options="gOwnersOptions" :owners-filter.sync="ownersFilter"
          :geofences-list="filteredGeofences.map((g) => ({ id: g.id, name: g.name, checked: g.checked }))"
          @disSelectGeofenceById="disSelectGeofenceById" :loading="loadingFetchgeofenceByDeivce" />
      </vue-perfect-scrollbar>
    </div>


    <RouteFooter :category="footerCategory" :data="footerData" :deviceData="deviceData" />


  </div>
</template>

<script>
import {
  BLink, BFormRadioGroup, BFormGroup, BFormCheckbox, BCard, BCardText, BRow,
  BCol, BCollapse, BButton, VBToggle, BCardBody,
  BAvatar,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import useAppCustomizer from "@core/layouts/components/app-customizer/useAppCustomizer"
//map

import Ripple from 'vue-ripple-directive'
import { useRouter } from '@core/utils/utils'

import { computed, onMounted, onUnmounted, ref, watch } from '@vue/composition-api'

import getRouteStore from '@/views/modules/maps/device-route/getRouteStore'
import store from '@/store'



import useMap from "@/views/modules/maps/uses/useMap";

import 'leaflet-routing-machine'
import 'leaflet-routing-machine/dist/leaflet-routing-machine.css'
import 'leaflet-routing-machine/src/localization'

import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'
import 'leaflet-polylinedecorator'
import 'leaflet-geometryutil'

import L from 'leaflet'
import { icon, LMap, LTileLayer, LMarker, LPopup, LTooltip } from "vue2-leaflet"


////drawing route

import deviceRoute from '@/views/modules/maps/device-route/deviceRoute'

// evensts list 

import EventsList from '@/views/modules/maps/EventsList.vue'

//footer 
import RouteFooter from '@/views/modules/maps/RouteFooter'
//reas draw 


import mapGeofence from '@/views/modules/maps/functions/mapGeofence'
import mapDrawGeofences from '@/views/modules/maps/mapDrawGeofences'
import GeofencesFliter from '@/views/modules/maps/GeofencesFliter'
import { owners } from '../../../app/reports/share/helper'

import axios from '@axios'
export default {
  components: {
    // BSV
    BLink,
    BFormRadioGroup,
    BFormCheckbox,
    BFormGroup,
    BCard, BCardText, BRow,
    BCol, BCollapse, BButton, VBToggle, BCardBody,
    BAvatar,
    // 3rd party
    vSelect,
    VuePerfectScrollbar,
    LMap, LTileLayer, LMarker, LPopup, LTooltip, BFormCheckbox,
    EventsList,
    GeofencesFliter,
    RouteFooter

  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
  },
  setup(props, { root }) {
    ////for check boxecs////
    const CAMP_AREA_IS_CHECKED = ref(false)
    const WORK_AREA_IS_CHECKED = ref(false)
    const LANDFILL_AREA_IS_CHECKED = ref(false)
    const IRRIGATION_AREA_IS_CHECKED = ref(false)
    const FILL_AREA_IS_CHECKED = ref(false)
    const FORBIDDEN_AREA_IS_CHECKED = ref(false)


    const manageGeofenceFilter = (cat, checkObj) => {

      if (checkObj == true) {
        const index = geofencesFilter.value.indexOf(cat);

        if (index < 0) {

          geofencesFilter.value.push(cat)
        }
      } else if (checkObj == false) {

        const index = geofencesFilter.value.indexOf(cat);
        if (index > -1) {
          geofencesFilter.value.splice(index, 1);
        }

      }

    }
    const setGeofenceFilter = (cat) => {
      switch (cat) {
        case 'FORBIDDEN_AREA':
          manageGeofenceFilter(cat, FORBIDDEN_AREA_IS_CHECKED.value)
          break;
        case 'FILL_AREA':
          manageGeofenceFilter(cat, FILL_AREA_IS_CHECKED.value)
          break;
        case 'IRRIGATION_AREA':
          manageGeofenceFilter(cat, IRRIGATION_AREA_IS_CHECKED.value)
          break;
        case 'LANDFILL_AREA':
          manageGeofenceFilter(cat, LANDFILL_AREA_IS_CHECKED.value)
          break;
        case 'CAMP_AREA':
          manageGeofenceFilter(cat, CAMP_AREA_IS_CHECKED.value)
          break;
        case 'WORK_AREA':
          manageGeofenceFilter(cat, WORK_AREA_IS_CHECKED.value)
          break;
      }


    }


    ////end ////////

    ///////device plan geofences //////////
    const DevicePlanGeofencesIsChecked = ref(false)
    const getDevicePlanGeofences = () => {



      if (DevicePlanGeofencesIsChecked.value == true) {
        geofences.value = geofences_orig.value.filter((g) => geofencePlanIdes.value.includes(g.id))

      } else {
        geofences.value = JSON.parse(JSON.stringify(geofences_orig.value))
      }

    }
    ////////////end///////////////////////


    const setView = ref(true)
    const perfectScrollbarSettings = { maxScrollbarLength: 100, wheelPropagation: true, }

    const { layoutType, skinOptions, } = useAppCustomizer()
    const isCustomizerOpenLeft = ref(false)
    const isCustomizerOpenRight = ref(false)

    const params = root.$route.params;


    function removeElementsByClass(className) {
      var elements = document.getElementsByClassName(className);
      while (elements.length > 0) {
        elements[0].parentNode.removeChild(elements[0]);
      }
    }
    removeElementsByClass('Vue-Toastification__container')
    //document.location.hash = document.location.hash+"#close";
    document.getElementsByTagName('html')[0].dir = "ltr"
    const currentPoints = ref([])
    const footerData = ref({})
    const deviceData = ref({})
    const footerCategory = ref()
    const eventFilter = ref([])
    const { map, url, center, mapRef, init_layers } = useMap()
    const zoom = 14;
    const { router } = useRouter()
    const eventItems = ref([])
    const eventsGeneralInfo = ref({})
    const eventListLoading = ref(true)
    const totalDistance = ref("  ")
    const filteredGeofences = ref([])

    const disSelectedGeofences = ref([])

    const geofencesFilter = ref([])
    const geofencesFilterIsChecked = ref([])
    const geofencesFilterDisabled = ref(true)
    const eventFilterDisabled = ref(true)
    //////////


    const { lineOptions, drawRouteLive, drawRouteForOnepoint } = deviceRoute(root)

    const geofencesFilterChange = ($event) => {


      geofencesFilter.value = JSON.parse(JSON.stringify(geofencesFilterIsChecked.value))

    }
    //const { fetchGeofenceByDevice, geofences, gOwnersOptions, gContractsOptions, gContractsOptions_orig, gCategoriesOptions, loadingFetchgeofenceByDeivce } = mapGeofence()
    const { fetchGeofenceByDevice, fetchGeofenceByDevicePlan, geofencePlanIdes, geofences, geofences_orig, loadingFetchgeofenceByDeivce } = mapGeofence()
    const gOwnersOptions = ref([])
    const gContractsOptions_orig = ref([])
    const gContractsOptions = ref([])
    const gCategoriesOptions = ref([])
    const gCategoriesOptions_orig = ref([])
    const gCategoriesFilter = ref([]); const gContractsFilter = ref([]); const ownersFilter = ref([])
    const { drawArea, removeAllGeos } = mapDrawGeofences(map)

    if (!store.hasModule('route'))
      store.registerModule('route', getRouteStore)

    onUnmounted(() => {
      if (store.hasModule('route'))
        store.unregisterModule('route')
    })


    const dateInfo = ref({ from: '', to: '' })
    const manageMapTheme=()=>{
    if(document.body.classList.contains('dark-layout')){
      document.body.classList.add('dark-map')
    } else { document.body.classList.remove('dark-map')}   

  }
  
    onMounted(() => {
      manageMapTheme()
      map.value = mapRef.value.mapObject
 
      dateInfo.value.from = params.from;
      dateInfo.value.to = params.to;

      getRoute(params.id, params.from, params.to)
      getEventsList(params.id, params.from, params.to)

      // fetchGeofenceByDevice(params.id)
      ////////add layers
      init_layers()
      fetchGeofenceByDevice(params.id)
      fetchGeofenceByDevicePlan(params.id)
      getDeviceInfo()
      map.value.on('baselayerchange', function (e) {
     // console.log(e.layer._url)
        if(e.layer._url.includes('ArcGIS') || e.layer._url.includes('lyrs=s') ){
          document.body.classList.remove('dark-map')
        }else{
          manageMapTheme()
        }
        
      });

    })
    const getDeviceInfo = () => {

      store.dispatch('route/getDeviceInfo', { ids: [params.id] }).then(response => {
        deviceData.value = response.data.data[0]
      }).catch(reason => console.log(reason))
    }



    const getEventsList = (id, from, to) => {
      store.dispatch('route/getEvents', {
        id: id,
        from: from,
        to: to
      }).then(response => {
        eventItems.value = response.data.days;
        eventsGeneralInfo.value = {
          device: response.data.device,
          totalDistance: response.data.totalDistance,
          numberOfDays: response.data.numberOfDays
        }
        eventListLoading.value = false;


      }).catch(reason => {
        console.log(reason)
      })
    }

    watch(geofences, () => {

      geofencesFilterDisabled.value = false;

      //when all geo loaded display all
      filteredGeofences.value = geofences.value.map((g) => Object.assign(g, { checked: true }))
      disSelectGeofenceById(0)

    })
    // watch(eventFilter, () => {

    //   drawRoute(currentPoints.value, map, eventFilter.value)
    // })

    const drawFilterdRoute = () => {
      drawRouteLive(currentPoints.value, map, eventFilter.value, setView.value)

      // map.value.setView([points[i].latitude,points[i].longitude], 17);
    }

    //top menu change
    watch(geofencesFilter, () => {

      getGeofencesByFilter()
    })


    const getGeofencesByFilter = () => {
      // console.log('geofencesFilter',geofencesFilter.value)
      filteredGeofences.value = geofences.value.filter(g => geofencesFilter.value.includes(g.category))
      if (DevicePlanGeofencesIsChecked.value == true && geofencesFilter.value.length == 0) {
        getDevicePlanGeofences()
      }

    }

    watch(filteredGeofences, () => {
      removeAllGeos()
      filteredGeofences.value.filter((g) => g.checked == true).map(g => drawArea(g))
      //  filter((g) => !disSelectedGeofences.value.includes(g.id)).map(g => drawArea(g))

    })



    const getInitDateTime = () => {
      var date = new Date();

      var dateStr =
        date.getFullYear() + "-" +
        (
          "00" + (date.getMonth() + 1)).slice(-2) + "-" +
        ("00" + date.getDate()).slice(-2) + " " + "00:00:00"



      return dateStr;

    }

    const getCurrentDateTime = () => {
      var date = new Date();

      var dateStr =
        date.getFullYear() + "-" +
        (
          "00" + (date.getMonth() + 1)).slice(-2) + "-" +
        ("00" + date.getDate()).slice(-2) + " " +

        ("00" + date.getHours()).slice(-2) + ":" +
        ("00" + date.getMinutes()).slice(-2) + ":" +
        ("00" + date.getSeconds()).slice(-2);

      return dateStr;
    }


    const getRoute = (id, from, to) => {

      new Promise((resolve, reject) => {
        axios.get('maps/getRoute?id=' + id + '&from=' + getInitDateTime() + '&to=' + getCurrentDateTime())
          .then(response => {
            currentPoints.value = response.data.points;
            totalDistance.value = response.data.totalDistance;
            footerData.value = response.data.footer
            footerCategory.value = response.data.category,
              drawRouteLive(response.data.points, map, eventFilter.value, setView.value)
            eventFilterDisabled.value = false;

            setTimeout(() => getRoute(id, from, to), 3000)
          })
          .catch(error => reject(error))
      })

    }
    const getEventPoint = (event) => {
      eventFilter.value = []
      drawRouteForOnepoint(currentPoints.value, map, event.point)
    }




    const disSelectGeofenceById = (id, event) => {
      // geofencesFilter.value=[]


      CAMP_AREA_IS_CHECKED.value = false;
      WORK_AREA_IS_CHECKED.value = false;
      LANDFILL_AREA_IS_CHECKED.value = false;
      IRRIGATION_AREA_IS_CHECKED.value = false;
      FILL_AREA_IS_CHECKED.value = false;
      FORBIDDEN_AREA_IS_CHECKED.value = false;

      if (id > 0) {
        const found = disSelectedGeofences.value.find(g => g == id)
        if (found == undefined && event == false) {
          disSelectedGeofences.value.push(id)

          // filteredGeofences.value=JSON.parse(JSON.stringify(newState))
        } if (found != undefined && event == true) {
          const index = disSelectedGeofences.value.indexOf(id);
          disSelectedGeofences.value.splice(index, 1)
        }

        removeAllGeos()
        filteredGeofences.value.filter((g) => !disSelectedGeofences.value.includes(g.id)).map(g => drawArea(g))
      } else {
        if (id == 0) {
          removeAllGeos()
          filteredGeofences.value.map(g => drawArea(g))
          filteredGeofences.value = filteredGeofences.value.map((g) => Object.assign(g, { checked: true }))
          disSelectedGeofences.value = []

        } else if (id == -1) {
          removeAllGeos()
          disSelectedGeofences.value = filteredGeofences.value.map((g) => g.id)
          filteredGeofences.value = filteredGeofences.value.map((g) => Object.assign(g, { checked: false }))
        }
      }

      filteredGeofences.value = filteredGeofences.value.map((g) => { if (g.id == id) { g.checked = event; } return g; })
    }

    ////// geofences filters change 

    const refilterGeofncesList = (filterBy) => {



      if (filterBy == 'owners') {
        if (ownersFilter.value.length != 0) {
          filteredGeofences.value = geofences.value.filter((g) => ownersFilter.value.includes(g.owner_id))
        } else {

          filteredGeofences.value = JSON.parse(JSON.stringify(geofences.value.filter((g) => gOwnersOptions.value.map(o => o.id).includes(g.owner_id))))

        }


      }
      if (filterBy == 'contracts') {
        if (gContractsFilter.value.length != 0) {
          filteredGeofences.value = geofences.value.filter((g) => gContractsFilter.value.includes(g.contract_id))
        } else {
          filteredGeofences.value = JSON.parse(JSON.stringify(geofences.value.filter((g) => gContractsOptions.value.map(o => o.id).includes(g.contract_id))))
        }


      }
      if (filterBy == 'categories') {

        if (gCategoriesFilter.value.length != 0) {
          filteredGeofences.value = geofences.value.filter((g) => gCategoriesFilter.value.includes(g.category))
        } else {

          filteredGeofences.value = JSON.parse(JSON.stringify(geofences.value.filter((g) => gCategoriesOptions_orig.value.includes(g.category))))
        }


      }
      // if(ownersFilter.value.length==0 &&  gContractsFilter.value.length==0 && gCategoriesFilter ){
      //   filteredGeofences.value=[]
      // }

    }
    /////refilter filters
    watch([ownersFilter], () => {

      gContractsOptions.value = gContractsOptions_orig.value.filter((c) => ownersFilter.value.includes(c.contractor_id));
      if (ownersFilter.value.length == 0) {
        gContractsOptions.value = JSON.parse(JSON.stringify(gContractsOptions_orig.value))
      }
      refilterGeofncesList('owners')
    })
    watch([gContractsFilter], () => {
      refilterGeofncesList('contracts')
    })

    watch([gCategoriesFilter], () => {

      refilterGeofncesList('categories')
    })
    //// end refilter filters
    store.dispatch('route/getFilterOptionsBy', {
      linkedWithDevice: params.id,
      type: 'geofence',

    }).then(response => {

      gOwnersOptions.value = response.data.data.owners
      gContractsOptions_orig.value = response.data.data.contracts
      gContractsOptions.value = response.data.data.contracts
      gCategoriesOptions.value = response.data.data.categories
      gCategoriesOptions_orig.value = response.data.data.categories

    }).catch(reason => {
      //emit('sendRequest', false)
      console.log(reason)
    })

    return {
      map, url, zoom, center, mapRef, init_layers,
      eventItems, eventsGeneralInfo, eventFilter,
      dateInfo, totalDistance,
      isCustomizerOpenLeft, isCustomizerOpenRight, layoutType,
      skinOptions,
      perfectScrollbarSettings,
      geofencesFilter,
      geofencesFilterDisabled,
      eventFilterDisabled,
      eventListLoading,
      getEventPoint,
      drawFilterdRoute,
      gOwnersOptions, gContractsOptions, gCategoriesOptions,
      gCategoriesFilter, gContractsFilter, ownersFilter,
      geofences, refilterGeofncesList, filteredGeofences, disSelectGeofenceById, loadingFetchgeofenceByDeivce, setView,

      geofencesFilterIsChecked,
      geofencesFilterChange,
      CAMP_AREA_IS_CHECKED,
      WORK_AREA_IS_CHECKED,
      LANDFILL_AREA_IS_CHECKED,
      IRRIGATION_AREA_IS_CHECKED,
      FILL_AREA_IS_CHECKED,
      FORBIDDEN_AREA_IS_CHECKED,
      setGeofenceFilter,
      deviceData, footerData, footerCategory,

      DevicePlanGeofencesIsChecked,
      getDevicePlanGeofences,
    }
  }
}
</script>
<style lang="less" >
@import './liveStyles.less';

.vue2leaflet-map {
  &.leaflet-container {
    height: 100vh;
    width: 100vw;
  }
}
</style>


<style lang="scss" scoped>
@import '@core/scss/vue/libs/vue-select.scss';
@import '~@core/scss/base/bootstrap-extended/include';
@import '~@core/scss/base/components/variables-dark';

.custom-control-label {
  color: black !important;
}

p.mb-0 ::after {

  background: red !important;


}

.leaflet-control {
  float: right !important;
}

.leaflet-left {
  right: 0 !important;
}

.customizer .customizer-section {
  padding: 1.5rem;
  border-bottom: 1px solid #ebe9f1;

  .dark-layout & {
    border-color: $theme-dark-border-color;
  }

  #skin-radio-group ::v-deep {
    .custom-control-inline {
      margin-right: 0.7rem;
    }
  }

  .form-group {
    margin-bottom: 1.5rem;
    ;

    &:last-of-type {
      margin-bottom: 0;
    }

    ::v-deep legend {
      font-weight: 500;
    }
  }
}

.mark-active {
  box-shadow: 0 0 0 0.2rem rgba(38, 143, 255, .5);
}

.ps-customizer-area {
  height: calc(100% - 83px)
}



[dir="ltr"] .customizer.customizer-left .customizer-toggle {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  right: -39px;
  left: auto;
  border-top-right-radius: 26px;
  border-bottom-right-radius: 26px;
}

.customizer-toggle {
  border-top-left-radius: 26px;
  border-bottom-left-radius: 26px;
}

[dir="ltr"] .customizer.customizer-left {
  left: -400px;
  -webkit-transition: left 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99);
  transition: left 0.4s cubic-bezier(0.05, 0.74, 0.2, 0.99);
  border-right: 1px solid rgba(34, 41, 47, 0.05);
}



[dir="ltr"] .customizer.customizer-left.open {
  left: 0;
}

////left

[dir="ltr"] .customizer.customizer-right .customizer-toggle {
  border-top-left-radius: 0px;
  border-bottom-left-radius: 0px;
  right: 0px;
  right: auto;
  border-top-right-radius: 26px;
  border-bottom-right-radius: 26px;
}






////map control css 
.map-control-top {

  position: absolute;

  right: 0;
  margin-top: 0.5rem;
  right: 2px;

  z-index: 999;
  box-sizing: border-box;
  display: flex;
  gap: 10px;
}

.filters {
  display: flex;
  justify-content: right;
}

.filter-item {
  background-color: white;
  padding: 1rem;
  margin-right: 2px;
}

.custom-control-item {
  flex-basis: 80px;

}

////end map control

.btn-round {
  border-radius: 18px 17px 0px 0px;



}


#collapse-1 {
  margin-top: -0px !important;
}

.btn.btn-round.btn-primary {
  padding: 9px;
}

////// ustomizer-rigth

@media only screen and (max-width: 1200px) {
  .filters {
    flex-direction: column;
  }
}

//////here popup custimizing
.custom-popup {
  color: #5b5959 !important;
  font-weight: bold;
  font-family: "Cairo", sans-serif !important;

}

.leaflet-popup-content {

  margin: 0px !important;
  min-width: 301px !important;
  box-sizing: border-box;
}

.custom-popup>.header {
  font-size: x-large;
  font-weight: bold;
  background-color: #78bc87;
  color: white;
}
</style>
